export default __webpack_public_path__ + "static/media/USD.a9be7120.svg";